import { render, staticRenderFns } from "./SidebarPart.vue?vue&type=template&id=f8ef5534&scoped=true"
import script from "./SidebarPart.vue?vue&type=script&lang=js"
export * from "./SidebarPart.vue?vue&type=script&lang=js"
import style0 from "./SidebarPart.vue?vue&type=style&index=0&id=f8ef5534&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ef5534",
  null
  
)

export default component.exports